precision highp float;

uniform sampler2D tMap;
uniform float uRand;
uniform float uTime;
uniform float uStrength;

varying vec2 vUv;

const int ITERATIONS = 60;

#pragma glslify: fbm3d = require(glsl-fractal-brownian-noise/3d)
#pragma glslify: snoise2 = require(glsl-noise/simplex/2d)
#pragma glslify: blendHardLight = require(glsl-blend/hard-light)
#pragma glslify: blendAdd = require(glsl-blend/add)
#pragma glslify: blendSoftLight = require(glsl-blend/soft-light)

float circularP(vec2 uv, float dist, float seed, float bias, float offset) {
  float ang = atan(uv.y, uv.x) + sin(dist + 4.1 * seed) * (1.2 - offset) * 2.0;
  ang += 3.14159 * (3.1 * seed);
  return clamp((sin((ang) * (13.0 + offset * float(ITERATIONS))) + bias) / (1.0 + bias), 0.0, 1.0);
}

void main() {
  vec4 col = texture2D(tMap, vUv);
  vec2 pos = gl_FragCoord.xy;

  vec2 posOffset = vec2(pos.x * pos.y + uRand * 231.5, pos.x + pos.y - uRand * 324.1);

  vec3 noisy = vec3(0.6) + snoise2(posOffset) * uStrength * 1.5;
  vec4 color = vec4(col.rgb, col.a);

  color.rgb = blendAdd(color.rgb, vec3(1.3) * fbm3d(vec3(vUv * 1.25, uTime), 6) * 0.34);

  vec2 uv = vUv * 2.;

  float dist = length(uv * 1.8);
  vec3 colDust = vec3(0.0);

  for (int i = 0; i < ITERATIONS; i++) {
    float offset = float(i) * 2. / float(ITERATIONS) * 2.2;
    vec2 pan = vec2(-uRand, 0.);
    float maskA = circularP(uv, dist, 1.0 * float(i), -0.999, offset);
    float dist2 = length(uv * 3.2 + pan);
    float maskB = circularP(uv + pan, dist2, 12.0 * float(i), -.7, offset);
    float mask = maskA * maskB;
    colDust = mix(colDust, vec3(1.), mask);
  }

  gl_FragColor = vec4(blendSoftLight(color.rgb, colDust * 2.0, .15), 1.);
  gl_FragColor.rgb = blendHardLight(noisy, gl_FragColor.rgb, .7);
  // gl_FragColor.rgb = dither(pos, halftone(gl_FragColor.rgb, vUv * 16.));
}

// void mainImage( out vec4 fragColor, in vec2 fragCoord )
// {

//     fragColor = vec4(col * 4.0, 1.0);
// }